import { StyleSheet, View } from 'react-native';
import { Controller, useFormContext } from 'react-hook-form';

import { Toggle, ToggleProps } from '../Toggle';
import { Text } from '../../Text';
import { spacing } from '../../../theme';

interface Props extends Omit<ToggleProps, 'onChange' | 'checked'> {
	name: string;
	label: string;
}

export const FormToggle = ({ name, label, ...toggleProps }: Props) => {
	const { control } = useFormContext();

	return (
		<View style={styles.toggleContainer}>
			<Text category="c1">{label}</Text>
			<Controller
				name={name}
				control={control}
				render={({ field: { onChange, value } }) => (
					<Toggle checked={value} onChange={onChange} {...toggleProps} />
				)}
			/>
		</View>
	);
};

const styles = StyleSheet.create({
	toggleContainer: {
		alignItems: 'flex-start',
		gap: spacing(),
	},
});
